module.exports = __webpack_public_path__ + "static/media/overview-icon.6c9deb78.svg";